const SubscriptionDetails = ({subscriptionDetails}) => {
   
    return (
        <div className="mjsdev-dtl-section mjsdev-dtl-section-half">
            <div className="mjsdev-dtl-sec-header"><h4>Subscription Details</h4></div>
            <div className="mjsdev-dtl-inner-container">
                <div className="mjsdev-dtl-row">
                    <span>Status</span>
                    <span>{subscriptionDetails?.paused ? (
                        <span title="All invoices generated by this subscription will be marked as uncollectible.">Paused</span>
                    ) : subscriptionDetails?.status || '-'}</span>
                </div>
                <div className="mjsdev-dtl-row">
                    <span>Monthly Total</span>
                    <span>${(Number(subscriptionDetails.amount || process.env.REACT_APP_STRIPE_MONTHLY_PRICING)).toFixed(2)}</span>
                </div>
                <div className="mjsdev-dtl-row">
                    <span>Yearly Total</span>
                    <span>${(Number(subscriptionDetails.amount || process.env.REACT_APP_STRIPE_MONTHLY_PRICING) * 12).toFixed(2)}</span>
                </div>
                <div className="mjsdev-dtl-row">
                    <span>Created At</span>
                    <span>
                        {new Date(subscriptionDetails.createdAt).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "long",
                            year: "numeric"
                        })}
                    </span>
                </div>
                <div className="mjsdev-dtl-row">
                    <span>Renewal Date</span>
                    <span>
                        {subscriptionDetails?.paused && <i title="Uncollectible" style={{color: "red"}} class="fa-solid fa-circle-exclamation"></i>}
                        {" "}
                        {subscriptionDetails.currentPeriodEnd
                            ? new Date(subscriptionDetails.currentPeriodEnd).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "long",
                                year: "numeric"
                            })
                            : "—"}
                    </span>

                </div>
            </div>
            <div className="mjsdev-dtl-sec-header"><h4>Customer Details</h4></div>
            <div className="mjsdev-dtl-inner-container">
                <div className="mjsdev-dtl-row">
                    <span>Name</span>
                    <span>{subscriptionDetails.user?.name || '-'}</span>
                </div>
                <div className="mjsdev-dtl-row">
                    <span>Email</span>
                    <span>{subscriptionDetails.user?.email || '-'}</span>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionDetails;
